import { ErrorBoundaryForPages } from '@hotjar/error-handler';
import type { ErrorBoundaryProps } from '@hotjar/error-handler';
import { useLocation } from 'react-router';

type ErrorBoundaryRouteProps = Required<
  Pick<ErrorBoundaryProps, 'children' | 'squadSentryTag' | 'featureName'>
>;

export function ErrorBoundaryRoute(props: ErrorBoundaryRouteProps): JSX.Element {
  // We want to reset the ErrorBoundary when the route changes
  // If we don't reset, the Fallback Page stays on after an exception has been thrown
  // Even if we go in another route
  const location = useLocation();

  return (
    <ErrorBoundaryForPages
      {...props}
      resetKeys={[location.key]}
      shouldShowToast={false}
      criticality="critical" // A route breaking is most probably an incident
    />
  );
}
